import api from '@http/api';

export interface IDoacoes {
  modelo: IDoacoesResultTable[];
  idDoacao: number;
  dataCadastro: string;
  IDCadastro: number;
  NomeCadastro: string;
  Valor: string;
  origemDoacaoDescricao: string;
}

export interface IDoacoesResultTable {
  idDoacao: string;
  IDCadastro: string;
}

class Services {
  public async GetLotesAbertos() {
    return await api
      .get('/api/LoteDoacao/lotes-abertos-usuario',)
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }


  public async GetDoacoesPorLote(idLote: number) {
    return await api
      .get('/api/LoteDoacao/PendentesPorLote', {
        params: { idLote },
      })
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }

  public async AprovarDoacoes(doacaoIds: number[], observacao: string) {
    return await api
      .post('/api/Doacao/AprovarDoacoes', { doacaoIds, observacao })
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }

  public async RecusarDoacoes(doacaoIds: number[], observacao: string) {
    return await api
      .post('/api/Doacao/RecusarDoacoes', { doacaoIds, observacao })
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }

  public async AprovarLote(loteId: number) {
    return await api
      .post( `/api/Doacao/AprovarLote?loteId=${loteId}`, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }

  public async RecusarLote(loteId: number) {
    return await api
      .post( `/api/Doacao/RecusarLote?loteId=${loteId}`, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }

  public async ReabrirLote(loteId: number, idUsuario: number) {
    return await api
    .post(`/api/LoteDoacao/reabrir/${loteId}?idUsuario=${idUsuario}`)

      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }

  public async gerarRecibo(doacaoId: any): Promise<{ error: boolean; response?: Blob }> {
    return await api
      .get(`/api/Doacao/GetReciboDoacao`, {
        params: { doacaoId },
        responseType: 'blob',
      })
      .then(response => ({
        error: false,
        response: response.data,
      }))
      .catch(() => ({ error: true }));
  }
}

export default new Services();
